<template>
  <van-popup
    v-model:show="innerShow"
    round
    position="bottom"
    :style="{ width: '100%', height: '80%' }"
  >
    <van-form @submit="onSubmit" class="form">
      <div>
        <div class="select-date">
          <van-button
            round
            :plain="state.calendar.active !== button"
            size="small"
            type="primary"
            v-for="(button, index) in state.calendar.options"
            :key="index"
            @click="setCalendarDefaultDate(button)"
            >{{ button.label }}</van-button
          >
        </div>
        <!-- 选择时间 -->
        <van-field
          v-model="state.calendar.fieldValue"
          readonly
          clickable
          label="报修时间"
          placeholder="点击选择报修时间"
          @click="state.calendar.show = true"
        />
        <van-calendar
          :allow-same-day="true"
          :min-date="state.calendar.minDate"
          :max-date="state.calendar.maxDate"
          :default-date="state.calendar.defaultDate"
          v-model:show="state.calendar.show"
          type="range"
          @confirm="calendarConfirm"
        />
        <!-- 选择时间 end -->
        <!-- 报修位置 -->
        <van-field
          v-model="state.place.fieldValue"
          readonly
          clickable
          label="报修位置"
          placeholder="点击选择报修位置"
          @click="state.place.show = true"
        />
        <place v-model:show="state.place.show" @confirm="placeConfirm" />
        <!-- 报修位置 end -->
        <!-- 报修部门 -->
        <van-field
          v-model="state.department.fieldValue"
          readonly
          clickable
          label="报修部门"
          placeholder="点击选择报修部门"
          @click="state.department.show = true"
        />
        <van-popup v-model:show="state.department.show" round position="bottom">
          <van-picker
            :columns-field-names="{
              text: 'department_name',
            }"
            :columns="state.department.columns"
            @cancel="state.department.show = false"
            @confirm="departmentConfirm"
          />
        </van-popup>
        <!-- 报修部门 end -->
        <!-- 关键词搜索 -->
        <van-field
          name="keyword"
          label="关键词"
          placeholder="可以根据关键词搜索"
          v-model="state.keyword"
        />
        <!-- 有无配件工单 -->
        <van-field name="switch" label="有无配件工单">
          <template #input>
            <van-switch
              v-model="state.isHavePart"
              active-value="2"
              inactive-value=""
              size="25"
            />
          </template>
        </van-field>
      </div>
      <!-- 有无配件工单 end -->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit">
          筛选
        </van-button>
      </div>
    </van-form>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
import { reactive } from "vue";
import moment from "moment";
import { baseService } from "@/service";
export default {
  name: "repair-filter",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["confirm", "update:show"],
  setup(props, { emit }) {
    const initState = () => {
      return {
        calendar: {
          active: null,
          options: [
            {
              label: "本年",
              value: [moment().startOf("year").toDate(), moment().toDate()],
            },
            {
              label: "本月",
              value: [moment().startOf("month").toDate(), moment().toDate()],
            },
            {
              label: "一周",
              value: [moment().subtract(7, "days").toDate(), moment().toDate()],
            },
            {
              label: "本日",
              value: [moment().toDate(), moment().toDate()],
            },
          ],
          fieldValue: "",
          value: [],
          show: false,
          defaultDate: [
            moment().subtract(1, "days").toDate(),
            moment().toDate(),
          ],
          minDate: moment("2015-01-01").toDate(),
          maxDate: moment().toDate(),
        },
        place: {
          show: false,
          fieldValue: "",
          selected: [],
        },
        department: {
          fieldValue: "",
          value: "",
          show: false,
          columns: [],
        },
        isHavePart: false,
        keyword: "",
      };
    };
    const state = reactive({ ...initState() });
    // calendar
    const calendarConfirm = (date, isButton) => {
      state.calendar.value = date;
      state.calendar.fieldValue = `${moment(date[0]).format(
        "YYYY-MM-DD"
      )} 至 ${moment(date[1]).format("YYYY-MM-DD")}`;
      if (!isButton) state.calendar.active = null;
      state.calendar.show = false;
    };

    const setCalendarDefaultDate = (button) => {
      state.calendar.active = button;
      state.calendar.defaultDate = button.value;
      calendarConfirm(button.value, true);
    };
    // place
    const placeConfirm = (value) => {
      state.place.fieldValue = value.fieldValue;
      state.place.selected = value.selected;
    };
    // department
    const getDepartmentList = async () => {
      const { data } = await baseService.departmentList();
      state.department.columns = [{ id: "", department_name: "无" }, ...data];
    };
    getDepartmentList();

    const departmentConfirm = (value) => {
      state.department.fieldValue =
        value.department_name === "无" ? "" : value.department_name;
      state.department.value = value.id;
      state.department.show = false;
    };

    // submit
    const onSubmit = () => {
      emit("update:show", false);
      emit("confirm", {
        calendar: state.calendar.value,
        place: state.place.selected,
        department: state.department.value,
        isHavePart: state.isHavePart,
        keyword: state.keyword,
      });
    };

    return {
      state,
      calendarConfirm,
      setCalendarDefaultDate,
      placeConfirm,
      departmentConfirm,
      onSubmit,
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.form {
  display: flex;
  padding-top: 20px;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.select-date {
  padding: 10px;
  & > button {
    margin-right: 5px;
  }
}
</style>
